import { gql } from '@apollo/client';

export const getSnappyCampaigns = gql`
  query getSnappyCampaigns {
    snappyCampaigns {
      name
      extSnappyCampaignId
    }
  }
`;
